/*
 * @Author: cn1994
 * @Date: 2023-02-26 15:29:45
 * @LastEditors: cn1994
 * @LastEditTime: 2024-01-26 16:03:45
 * @Description: file content
 */
const routes = [{
  path: '/personInfo', // 个人信息页面
  name: 'personInfo',
  meta: {
    title: '个人信息',
    volcengine: true,
  },
  component: () => import('../pages/personInfo/index.vue'),
}
]

export default routes
